import React from 'react';
import { Trans } from 'react-i18next';
import { hot } from 'react-hot-loader';

const CollateralSecurity = ({ loanObject = {} }) => {
	if (loanObject && loanObject.collateral) {
		const DETAILS = loanObject.collateral;
		return (
			<p className="justify">
				<Trans i18nKey="loan_agreement.with_collateral_security">
					<strong style={{ marginRight: '2px' }}>SECURITY. </strong> The loan is secured by collateral.
					BORROWER agrees that until the Loan together with interest is paid in full, the Loan will be secured
					by {{ DETAILS }} and BORROWER hereby grants to LENDER a security interest in and to such property.
				</Trans>
			</p>
		);
	} else {
		return (
			<p className="justify">
				<Trans i18nKey="loan_agreement.with_no_collateral_security">
					<strong style={{ marginRight: '2px' }}>SECURITY. </strong> The loan is not secured by collateral.
				</Trans>
			</p>
		);
	}
};

export default hot(module)(CollateralSecurity);
